module.exports = __webpack_public_path__ + "img/blob-wave-webp.027f5107.webp";